import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-entity-contact-toplines',
  templateUrl: './entity-contact-toplines.component.html'
})
export class EntityContactToplinesComponent {

  @Input() entityId: string;
  @Input() campaignId: string;

  constructor() { }
}
